var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookGris(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #747474;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M512,257.6c0,127.8-93.7,233.7-216.1,252.9v-178.4h59.5l11.3-73.8h-70.8v-47.9c0-20.2,9.9-39.9,41.6-39.9h32.2v-62.8s-29.2-5-57.2-5c-58.3,0-96.4,35.3-96.4,99.3v56.3h-64.8v73.7h64.8v178.4C93.8,491.2,0,385.3,0,257.6S114.6,1.6,256,1.6s256,114.6,256,256Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookGris);
export default __webpack_public_path__ + "static/media/facebook-gris.59ec0ba58eb588b8c8347346a1351c32.svg";
export { ForwardRef as ReactComponent };